import type { Environment } from 'src/types/types';

export const getOverridedCandidateGraphEndpoint = (
  environment: Environment,
): string | undefined => {
  const PROD_INT_CLOUD_URL =
    'http://candidate-graphql.int-cloud.seek.com.au/graphql';

  const STAGING_INT_CLOUD_URL =
    'http://candidate-graphql.staging.int-cloud.seek.com.au/graphql';

  switch (environment) {
    case 'development': {
      // Uncomment to use prod graphql server (no VPN login required)
      // return 'https://www.seek.com.au/graphql';

      // Uncomment to use prod graphql server (VPN login required)
      // return typeof window === 'undefined'
      //   ? 'http://candidate-graphql.sunsetting.int-cloud.seek.com.au/graphql'
      //   : 'https://www.seek.com.au/graphql';

      // Uncomment to use staging graphql server
      // return typeof window === 'undefined'
      //   ? 'http://candidate-graphql.sunsetting.staging.int-cloud.seek.com.au/graphql'
      //   : 'https://www.staging.seek.com.au/graphql';

      // Uncomment to use dark prod graphql server with branch. Replace test-env with your branch name.
      // return `https://candidate-graphql-dark-prod.cloud.seek.com.au/graphql?branch=test-env`;

      // Uncomment to use dark prod graphql server
      // return `https://candidate-graphql-dark-prod.cloud.seek.com.au/graphql;

      // Uncomment to use local candidate-graphql-api graphql server
      return 'http://localhost:8001/graphql';
    }

    case 'production':
      return typeof window === 'undefined' ? PROD_INT_CLOUD_URL : undefined;

    case 'staging':
      return typeof window === 'undefined' ? STAGING_INT_CLOUD_URL : undefined;

    default:
      throw new Error(`Unknown environment: ${environment}`);
  }
};
